<app-audit-subbar></app-audit-subbar>

<div class="audit-tab-body" style="position: relative">
  <div class="opp-wrap">
    <!-- No data -->
    <div class="opp-empty" *ngIf="!hasData && !isLoading">
      <p>No opportunities data available for this audit yet.</p>
    </div>

    <ng-container *ngIf="hasData">
      <div class="opp-head">
        <h3 class="opp-title">{{ label }}</h3>
        <p class="opp-desc">
          All prioritized opportunities across UX, Conversion Readiness, SEO,
          GEO and Technical Foundations — ranked by evidence strength and
          expected commercial direction.
        </p>
        <p class="opp-meta">{{ metaText }}</p>
      </div>

      <div class="custom_table-container custom_table-container-v2">
        <table class="custom_table opp-table">
          <!-- Widths live in CSS (not inline) so they can tighten on narrower
               viewports — see opportunities.component.css. -->
          <colgroup>
            <col class="opp-col-idx" />
            <col class="opp-col-name" />
            <col class="opp-col-ev" />
            <col class="opp-col-rel" />
            <col class="opp-col-conf" />
            <col class="opp-col-act" />
          </colgroup>
          <thead>
            <tr>
              <th><div>#</div></th>
              <th><div>Opportunity</div></th>
              <th class="sort-value">
                <div>
                  Evidence
                  <svg
                    (click)="sortData('score')"
                    class="custom_table_sort-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    [ngClass]="{
                      active: sortKey === 'score' && sortOrder === 'desc',
                    }"
                  >
                    <path
                      d="M12 8V15"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </th>
              <th><div>Commercial relevance</div></th>
              <th class="sort-value">
                <div>
                  Confidence
                  <svg
                    (click)="sortData('confidence')"
                    class="custom_table_sort-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    [ngClass]="{
                      active: sortKey === 'confidence' && sortOrder === 'desc',
                    }"
                  >
                    <path
                      d="M12 8V15"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 12L12 8"
                      stroke="#5f5d6e"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </th>
              <th><div>Recommended action</div></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of items; let i = index">
              <td class="opp-index">{{ i + 1 }}</td>
              <td>
                <div class="opp-name">{{ o.title }}</div>
                <div class="opp-page" *ngIf="o.page">{{ o.page }}</div>
              </td>
              <td class="opp-evidence">{{ o.evidence }}</td>
              <td class="opp-reason">{{ o.reason }}</td>
              <td>
                <span class="opp-badge" [ngClass]="o.confidenceClass">{{
                  o.confidenceLabel
                }}</span>
              </td>
              <td class="opp-action">{{ o.recommendation }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

  <!-- Competitor switch overlay (scoped to the content, below the sub-bar) -->
  <div class="loading-data-overlay" *ngIf="competitorSwitching$ | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="loading-data-overlay" *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
